/* Contact page enhancement. Native Shopify form and links work without it. No form values in analytics. */
(() => {
  'use strict';
  if (window.wnfcInitialized) return;
  window.wnfcInitialized = true;

  const measurementId = 'G-0JE425EEKS';
  const pendingKey = 'wnfc-note-pending';
  // Both showrooms: [open hour, close hour] by weekday, Sunday = 0.
  const HOURS = { 0: [11, 17], 1: [10, 18], 2: [10, 18], 3: [10, 18], 4: [10, 18], 5: [10, 18], 6: [10, 18] };
  const DAY = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const ORDER_TOPICS = ['Order or delivery', 'Return or damage'];

  let privacyRequested = false;
  let privacyAttempts = 0;
  function ensurePrivacyApi() {
    if (window.Shopify?.customerPrivacy || privacyRequested) return;
    if (typeof window.Shopify?.loadFeatures === 'function') {
      privacyRequested = true;
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
    } else if (++privacyAttempts < 10) window.setTimeout(ensurePrivacyApi, 500);
  }
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const track = (name, params = {}) => {
    if (!allowed() || typeof window.gtag !== 'function') return false;
    window.gtag('event', name, { send_to: measurementId, page_location: 'https://whatsnewfurniture.com/pages/contact-us', page_title: 'Contact What’s New Furniture', form_name: 'contact', ...params });
    return true;
  };
  const storage = {
    get() { try { return Number(sessionStorage.getItem(pendingKey)); } catch { return 0; } },
    set() { try { sessionStorage.setItem(pendingKey, String(Date.now())); } catch { /* Form works without storage. */ } },
    clear() { try { sessionStorage.removeItem(pendingKey); } catch { /* No storage. */ } }
  };

  function pacificNow() {
    const parts = {};
    try {
      new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23', weekday: 'short' })
        .formatToParts(new Date()).forEach(p => { parts[p.type] = p.value; });
    } catch { return null; }
    const weekday = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(parts.weekday);
    if (weekday < 0) return null;
    return { day: weekday, minutes: Number(parts.hour) * 60 + Number(parts.minute), date: `${parts.year}-${parts.month}-${parts.day}` };
  }
  const hourLabel = h => `${h % 12 || 12}${h < 12 ? 'am' : 'pm'}`;
  function addDays(isoDate, n) {
    const d = new Date(`${isoDate}T12:00:00Z`);
    d.setUTCDate(d.getUTCDate() + n);
    return d.toISOString().slice(0, 10);
  }
  function status(closed) {
    const now = pacificNow();
    if (!now) return null;
    const isClosedDay = offset => closed.includes(addDays(now.date, offset));
    const [open, close] = HOURS[now.day];
    if (!isClosedDay(0) && now.minutes >= open * 60 && now.minutes < close * 60) {
      return { open: true, pill: `Open until ${hourLabel(close)}`, line: `Open now until ${hourLabel(close)}` };
    }
    if (!isClosedDay(0) && now.minutes < open * 60) {
      return { open: false, pill: `Opens at ${hourLabel(open)}`, line: `Closed now. Opens today at ${hourLabel(open)}` };
    }
    for (let i = 1; i <= 14; i++) {
      if (isClosedDay(i)) continue;
      const day = (now.day + i) % 7;
      const when = i === 1 ? 'tomorrow' : DAY[day];
      return { open: false, pill: `Opens ${when} ${hourLabel(HOURS[day][0])}`, line: `Closed now. Opens ${when} at ${hourLabel(HOURS[day][0])}` };
    }
    return null;
  }

  function applyStatus(root) {
    const closed = (root.dataset.wnfcClosed || '').split(/[\s,]+/).filter(d => /^\d{4}-\d{2}-\d{2}$/.test(d));
    const s = status(closed);
    if (!s) return;
    const hero = root.querySelector('[data-wnfc-hero-status]');
    if (hero) {
      hero.classList.toggle('is-open', s.open);
      hero.classList.toggle('is-closed', !s.open);
      hero.querySelector('[data-wnfc-status-text]').textContent = s.open
        ? `${s.line} at both showrooms.`
        : `${s.line}.`;
    }
    root.querySelectorAll('[data-wnfc-store]').forEach(store => {
      const pill = store.querySelector('[data-wnfc-store-status]');
      if (pill) {
        pill.textContent = s.pill;
        pill.classList.toggle('is-open', s.open);
        pill.classList.toggle('is-closed', !s.open);
        pill.hidden = false;
      }
    });
  }

  function focusForm() {
    const section = document.getElementById('contact-form');
    if (!section) return;
    history.replaceState(null, '', '#contact-form');
    section.scrollIntoView({ behavior: 'auto', block: 'start' });
    document.getElementById('wnfc-form-heading')?.focus({ preventScroll: true });
  }

  function init() {
    const root = document.querySelector('[data-wnfc-page]');
    if (!root || root.dataset.wnfcReady) return;
    root.dataset.wnfcReady = 'true';
    ensurePrivacyApi();
    applyStatus(root);
    window.setInterval(() => applyStatus(root), 60000);

    const section = root.querySelector('#contact-form');
    const form = section?.querySelector('form');
    const success = section?.querySelector('[data-wnfc-success]');
    const serverError = section?.querySelector('[data-wnfc-server-error]');
    if (success || serverError) (success || serverError).focus({ preventScroll: true });
    if (success) {
      let attempts = 0;
      const report = () => {
        const pending = storage.get();
        if (!(pending > 0) || Date.now() - pending >= 30 * 60 * 1000) { storage.clear(); return; }
        const ready = typeof window.Shopify?.customerPrivacy?.analyticsProcessingAllowed === 'function';
        if (ready && !allowed()) { storage.clear(); return; }
        if (track('wnf_contact_note_success', { submission_status: 'shopify_success_state' })) { storage.clear(); return; }
        if (++attempts < 30) window.setTimeout(report, 500);
      };
      report();
    }
    if (serverError) storage.clear();

    if (form) {
      const orderField = form.querySelector('[data-wnfc-order-field]');
      const phoneRow = form.querySelector('[data-wnfc-phone-row]');
      const syncOrder = () => {
        if (!orderField) return;
        const topic = form.querySelector('input[name="contact[Topic]"]:checked')?.value;
        const show = ORDER_TOPICS.includes(topic) || Boolean(orderField.querySelector('input').value);
        orderField.hidden = !show;
        phoneRow?.classList.toggle('is-single', !show);
      };
      syncOrder();
      form.addEventListener('change', e => { if (e.target.name === 'contact[Topic]') syncOrder(); });
      let started = false;
      form.addEventListener('input', e => {
        if (!e.isTrusted) return;
        if (!started) started = track('wnf_contact_form_start');
        e.target.removeAttribute('aria-invalid');
        e.target.setCustomValidity?.('');
        const error = form.querySelector('[data-wnfc-client-error]');
        if (error) error.hidden = true;
      });
      form.addEventListener('invalid', e => e.target.setAttribute('aria-invalid', 'true'), true);
      form.addEventListener('submit', e => {
        const name = form.querySelector('[name="contact[name]"]');
        const body = form.querySelector('[name="contact[body]"]');
        for (const field of [name, body]) {
          if (field && !field.value.trim()) {
            e.preventDefault();
            field.setCustomValidity(field === name ? 'Please add your name.' : 'Please add a short message.');
            field.reportValidity();
            return;
          }
        }
        if (navigator.onLine === false) {
          e.preventDefault();
          const error = form.querySelector('[data-wnfc-client-error]');
          error.textContent = 'You appear to be offline, so your note wasn’t sent. Check your connection and try again. You can also call or text (503) 235-3454 while we’re open.';
          error.hidden = false;
          return;
        }
        if (allowed()) storage.set();
        // Shopify owns navigation, CAPTCHA, validation and delivery. Never infer success here.
      });
    }

    root.addEventListener('click', e => {
      const jump = e.target.closest('[data-wnfc-jump]');
      if (jump && jump.getAttribute('href') === '#contact-form') {
        e.preventDefault();
        focusForm();
        return;
      }
      const tracked = e.target.closest('[data-wnfc-track]');
      if (tracked) track('wnf_contact_channel_click', { contact_channel: tracked.dataset.wnfcTrack });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
